<template>
  <v-app>
    <!-- Router -->
    <v-main>
      <router-view/>
    </v-main>

    <!-- Footer  -->
    <v-footer app class="pa-0" v-if="getLogeadoLMS">
      <Navegador/>
    </v-footer>

     <NoInternet v-if="!estatusInternet"/>

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
        <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
        <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
      </symbol>
    </svg>

  </v-app>
</template>

<script>
  import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token,
  } from '@capacitor/push-notifications';
  // Componentes
  import { Device } from '@capacitor/device';

  // Componentes
  import Navegador  from '@/components/Navegador.vue'
  import NoInternet from '@/components/alertas/NoInternet.vue'

  // Librerías y más
  import { mapGetters, mapActions } from 'vuex'

  // Capacitor
  import { Network } from '@capacitor/network';

  export default {
    components:{
      Navegador,
      NoInternet,
    },

    name: 'App',

    data: () => ({
      drawer: true,
      drawer2:false,
      mini:false,
      escuela:2,
      color_active:'',
      estatusInternet: false
    }),

    async created ( ){

      if( this.getUsuarioLMS ){
        // Actualizar el tipo de dispositivo, esto es para poder recibir notificaciones
        const info = await Device.getInfo();

        const payload = { id: this.getUsuarioLMS.id, dispositivo: info.operatingSystem }
        this.$http.post('usuario.tipodispositivo', payload).then( response => {
          this.cargar = false
        }).catch( error => {
          this.cargar = false
          if( error.status == 400 || error.status == 500){
            this.parametros.mensaje      = error.body.message
            this.parametros.dialogError  = true 
            this.parametros.color        = '#FF2C2C' 
            this.respuestaAlerta         = true 
          }
        }).finally(()=>{ this.cargar = false })
      }

      Network.addListener('networkStatusChange', status => {
        this.estatusInternet = status.connected ;
      });

      const status = await Network.getStatus();
      this.estatusInternet = status.connected ;
    },


    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),

      salir(){
        this.salirLogin()
      },

      
    },

    computed:{
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),
    }
  };
</script>

<style>
  

</style>

